<ion-tabs>
  <ion-tab-bar slot="bottom">
    <ion-tab-button
      *ngIf="navigationTabSlot as navSlot"
      [tab]="navSlot.tab"
      (click)="navSlot.opensMenu ? openMenu() : null"
      [attr.aria-label]="navSlot.ariaLabelKey ? (navSlot.ariaLabelKey | translate) : null"
    >
      <ion-icon [src]="navSlot.icon" aria-hidden="true"></ion-icon>
    </ion-tab-button>

    <ion-tab-button
      *ngIf="wearablesTabSlot as wearablesSlot"
      [tab]="wearablesSlot.tab"
      [attr.aria-label]="wearablesSlot.ariaLabelKey ? (wearablesSlot.ariaLabelKey | translate) : null"
    >
      <ion-icon [src]="wearablesSlot.icon" aria-hidden="true"></ion-icon>
    </ion-tab-button>

    <ion-tab-button
      *ngIf="healthScoreTabSlot as healthSlot"
      [tab]="healthSlot.tab"
      [attr.aria-label]="healthSlot.ariaLabelKey ? (healthSlot.ariaLabelKey | translate) : null"
    >
      <ion-icon [src]="healthSlot.icon" aria-hidden="true"></ion-icon>
    </ion-tab-button>

    <ion-tab-button
      *ngIf="pointsTabSlot as pointsSlot"
      [tab]="pointsSlot.tab"
      [attr.aria-label]="pointsSlot.ariaLabelKey ? (pointsSlot.ariaLabelKey | translate) : null"
    >
      <div class="points-container" *ngIf="pointsSlot.showGameBadge; else pointsSlotIcon">
        <ion-icon [src]="pointsSlot.icon" aria-hidden="true"></ion-icon>
        <div class="game-available-badge" *ngIf="gameAvailable"></div>
      </div>
      <ng-template #pointsSlotIcon>
        <ion-icon [src]="pointsSlot.icon" aria-hidden="true"></ion-icon>
      </ng-template>
    </ion-tab-button>

    <ion-tab-button
      *ngIf="notificationTabSlot as notificationSlot"
      [tab]="notificationSlot.tab"
      [attr.aria-label]="notificationSlot.ariaLabelKey ? (notificationSlot.ariaLabelKey | translate) : null"
    >
      <div class="notification-container">
        <ion-icon [src]="notificationSlot.icon" aria-hidden="true"></ion-icon>
        <div
          class="notification-badge"
          *ngIf="notificationSlot.showNotificationBadge && notificationCount"
        ></div>
      </div>
      <span class="sr-only">{{ 'home-page.aria.tab.notifications' | translate }}</span>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
